import { Transition } from '@headlessui/react';
import { CheckCircleIcon, ExclamationCircleIcon, XCircleIcon } from '@heroicons/react/outline';
import { XIcon } from '@heroicons/react/solid';
import classNames from 'classnames';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { NotificationType } from '../../types/NotificationType';
const Notification = ({
  isVisible,
  setIsVisible,
  notificationType,
  title,
  message
}) => {
  const {
    t
  } = useTranslation();
  const positioningClassNames = classNames('fixed', 'inset-0', 'flex', 'items-end', 'px-4', 'z-50', 'py-6', 'pointer-events-none', 'sm:p-6', 'sm:items-start');
  const wrapperClassNames = classNames('w-full', 'flex', 'flex-col', 'items-center', 'space-y-4', 'sm:items-end');
  const bubbleClassNames = classNames('max-w-md', 'w-full', 'bg-white', 'shadow-lg', 'rounded-lg', 'pointer-events-auto', 'ring-1', 'ring-black', 'ring-opacity-5', 'overflow-hidden');
  const closeButtonClassNames = classNames('bg-white', 'rounded-md', 'inline-flex', 'text-gray-400', 'hover:text-gray-500', 'focus:outline-none', 'focus:ring-2', 'focus:ring-offset-2', 'focus:ring-indigo-500');
  const titleTestId = 'notificationTitle';
  const messageTestId = 'notificationMessage';
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "notification",
    "aria-live": "assertive",
    className: positioningClassNames
  }, /*#__PURE__*/React.createElement("div", {
    className: wrapperClassNames
  }, /*#__PURE__*/React.createElement(Transition, {
    show: isVisible,
    as: Fragment,
    enter: "transform ease-out duration-300 transition",
    enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
    enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: bubbleClassNames
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start"
  }, notificationType !== NotificationType.DEFAULT && /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 self-center px-2"
  }, notificationType === NotificationType.SUCCESS && /*#__PURE__*/React.createElement(CheckCircleIcon, {
    className: "h-6 w-6 text-green-600",
    "aria-hidden": "true"
  }), notificationType === NotificationType.WARNING && /*#__PURE__*/React.createElement(ExclamationCircleIcon, {
    className: "h-6 w-6 text-amber-600",
    "aria-hidden": "true"
  }), notificationType === NotificationType.ERROR && /*#__PURE__*/React.createElement(XCircleIcon, {
    className: "h-6 w-6 text-red-600",
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement("div", {
    className: "ml-3 w-0 flex-1 pt-0.5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-lg font-bold text-gray-800",
    "data-testid": titleTestId
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "mt-1 text-base text-gray-500",
    "data-testid": messageTestId
  }, message)), /*#__PURE__*/React.createElement("div", {
    className: "ml-4 flex flex-shrink-0"
  }, /*#__PURE__*/React.createElement("button", {
    className: closeButtonClassNames,
    type: "button",
    onClick: () => {
      setIsVisible(false);
    },
    "data-testid": "closeNotification"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, t('Close')), /*#__PURE__*/React.createElement(XIcon, {
    className: "h-5 w-5",
    "aria-hidden": "true"
  })))))))));
};
export default Notification;